import { SidebarPanel as Root } from "./sidebar-panel";
import { SidebarHeader as Header } from "./sidebar-header";
import { SidebarContent as Content } from "./sidebar-content";
import { SidebarTitle as Title } from "./sidebar-title";
import { SidebarSubTitle as SubTitle } from "./sidebar-sub-title";

export type { ISidebarContentRef } from "./sidebar-content";

export const SidebarPanel = {
	Root,
	Header,
	Content,
	Title,
	SubTitle,
};
